var isClickInprogress = false;
var isModelAllreadyOpen = false;
function waitForElm(selector) {
    return new Promise((resolve) => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(() => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
    });
}

function handleRadioBtn() {
    $('.shade-circle-wrapper').each(function () {
        var $button = $(this);

        $button.attr('role', 'radio');
        $button.attr('tabindex', '-1');

        waitForElm('.click-first-button').then((elm) => {
            $(elm).attr('tabindex', '0').attr('aria-checked', 'true');
        });
    });

    $('.shade-circle-wrapper').on('keyup', function (event) {
        var $buttons = $('.shade-circle-wrapper');
        var currentIndex = $buttons.index(this);
        var nextIndex, prevIndex;
    
        if (event.key === 'ArrowRight') {
            nextIndex = (currentIndex + 1) % $buttons.length;
            $buttons
                .attr('tabindex', '-1')
                .eq(nextIndex)
                .attr('tabindex', '0')
                .attr('aria-checked', 'true')
                .focus()
                .click();
        } else if (event.key === 'ArrowLeft') {
            prevIndex = (currentIndex - 1 + $buttons.length) % $buttons.length;
            $buttons
                .attr('tabindex', '-1')
                .eq(prevIndex)
                .attr('tabindex', '0')
                .attr('aria-checked', 'true')
                .focus()
                .click();
        }
    });
}

function initShadeFinderVto() {
    var selectedValueUrl = $(".display-vto-sf").attr('data-href');
    isClickInprogress = true;
    if (!isModelAllreadyOpen) {
        var isIphoneClass = navigator.userAgent.match(/(iPod|iPhone|iPad)/) ? " iphone-shade-finder" : ""
        var htmlString = '<!-- Modal -->'
            + '<div class="modal fade" id="vto-sf-modal" role="dialog">'
            + '<div class="modal-dialog vto-dialog container">'
            + '<!-- Modal content-->'
            + '<div class="modal-content">'
            + '<div class="modal-body shade-finder-vto-body' + isIphoneClass + '"><button type="button" class="hidden close close-vto-modal pull-right" data-dismiss="modal">&times;</button><button class="hidden retry-vto-sf btn btn-primary">'+ $("#tryagain").val() +'</button></div>'
            + '</div>'
            + '</div>'
            + '</div>';
        $('body').append(htmlString);
        isModelAllreadyOpen = true;
    }
    
    $('.modal-body').spinner().start();
    $.ajax({
        url: selectedValueUrl,
        method: 'GET',
        dataType: 'html',
        success: function (data) {
            var $html = $('<div>').append($.parseHTML(data));
            $('.shade-finder-vto-body').empty().append($html);
            if ($('.shade-finder-vto-body').find('.vto-revamp').length) {
                $('.shade-finder-vto-body').parents('#vto-sf-modal').addClass('vto-revamp-modal');
            }
            $('#vto-sf-modal').modal('show');
            isClickInprogress = false;
            $(document).trigger('sfvto:init');
            handleRadioBtn();
        },
        error: function () {
            isClickInprogress = false;
        }
    });
}

$(window).on('load', function() {
    $(document).off('click', '.display-vto-sf').on('click', '.display-vto-sf', function (e) {
        $.spinner().start();
        e.preventDefault();

        $('#one-to-one-initiation').addClass('d-none');

        if (isClickInprogress) {
            return;
        }

        // Check if an optin should be displayed
        if ($("#optin-vto-shadefiner").length && !isModelAllreadyOpen) {
            $("#optin-vto-shadefiner").modal("show");
    
            $(".button-optin-submit").off('click').on("click", function() {
                $("#optin-vto-shadefiner").modal("hide");
                initShadeFinderVto();
            })
        } else {
            initShadeFinderVto();
        }
    });

    $(document).on('click', '.modal-header-sf button', function () {
        $.spinner().stop();
    });
});